/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Pill_StartInputs */

const en_ui_onboarding_pill_start = /** @type {(inputs: Ui_Onboarding_Pill_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start setup`)
};

const de_ui_onboarding_pill_start = /** @type {(inputs: Ui_Onboarding_Pill_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einrichtung starten`)
};

/**
* | output |
* | --- |
* | "Start setup" |
*
* @param {Ui_Onboarding_Pill_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_pill_start = /** @type {((inputs?: Ui_Onboarding_Pill_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Pill_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_pill_start(inputs)
	return de_ui_onboarding_pill_start(inputs)
});